import * as React from 'react';
import * as styles from './styles.css';
import { Outside } from '@cian/ui-kit';

import { SearchTextHistoryItem } from '../SearchTextHistoryItem';
import { ISearchTextHistoryProps } from './types';

export const SearchTextHistoryMobile: React.FC<ISearchTextHistoryProps> = props => {
  const { isOpen, children, onHistoryItemClick, onOutsideHistoryListClick, searchHistoryList } = props;

  return (
    <Outside onOutside={onOutsideHistoryListClick}>
      <div>
        {children}
        {isOpen && (
          <div className={styles['container']}>
            {searchHistoryList.map((el, i) => (
              <SearchTextHistoryItem key={i} onClick={() => onHistoryItemClick(el)}>
                {el}
              </SearchTextHistoryItem>
            ))}
          </div>
        )}
      </div>
    </Outside>
  );
};

SearchTextHistoryMobile.displayName = 'SearchTextHistoryMobile';
